export const contactsTranslations = {
  ru: {
    backBtn: "Назад к документам",
    title: "Контакты и реквизиты",
    subtitle: "Актуальная информация для связи с командой проекта",
    s1: {
      title: "1. Контактная информация",
      desc: "Мы всегда готовы помочь вам с решением любых вопросов. Пожалуйста, используйте официальные каналы связи для обращения в службу поддержки. Обращения обрабатываются в порядке очереди, стандартное время ответа составляет от 24 до 48 часов.",
      emailLabel: "Email поддержка",
      discordLabel: "Discord сервер",
      websiteLabel: "Официальный сайт",
      tipLabel: "Совет:",
      tipText: " При обращении в поддержку через email, пожалуйста, указывайте ваш игровой никнейм и максимально подробно описывайте суть проблемы — это поможет нам решить ваш вопрос гораздо быстрее."
    },
    s2: {
      title: "2. Юридические реквизиты",
      desc: "Услуги на проекте предоставляются официально. Ниже представлены реквизиты, на основании которых осуществляется деятельность проекта Royolands.",
      orgLabel: "Организация",
      orgValue: "ИП Воеводин Никита Александрович",
      ogrnipLabel: "ОГРНИП",
      innLabel: "ИНН"
    }
  },
  en: {
    backBtn: "Back to documents",
    title: "Contacts & Details",
    subtitle: "Up-to-date contact information for the project team",
    s1: {
      title: "1. Contact Information",
      desc: "We are always ready to help you with any questions. Please use the official communication channels to contact customer support. Requests are processed on a first-come, first-served basis, with a standard response time of 24 to 48 hours.",
      emailLabel: "Email support",
      discordLabel: "Discord server",
      websiteLabel: "Official website",
      tipLabel: "Tip:",
      tipText: " When contacting support via email, please include your in-game nickname and describe the issue in as much detail as possible — this will help us resolve your issue much faster."
    },
    s2: {
      title: "2. Legal Details",
      desc: "Services on the project are provided officially. Below are the details under which the Royolands project operates.",
      orgLabel: "Organization",
      orgValue: "IE Voevodin Nikita Aleksandrovich",
      ogrnipLabel: "OGRNIP",
      innLabel: "TIN"
    }
  }
};